"use client";

import { useSidebar } from "@/context/sidebar-context";
import SidebarAccount from "./sidebar/content/sidebar-account";

const Paywall = () => {
  const sidebar = useSidebar();

  return (
    <div className="text-center p-4">
      <p className="mb-0 font-semibold">Redan konto? Bra!</p>
      <button
        className="m-0 text-blue-link underline"
        onClick={() => sidebar.open(<SidebarAccount />)}
      >
        Logga in för att fortsätta läsa
      </button>
      <h4 className="text-4xl font-bold py-6 sm:max-w-[75%] m-auto">
        Skapa konto för att ta del av innehållet
      </h4>
      <button
        className="btn btn-primary mt-2"
        onClick={() => sidebar.open(<SidebarAccount />)}
      >
        Skapa konto
      </button>
    </div>
  );
};

export default Paywall;
